import './index.css';
import {Taskbar} from "./Components/Taskbar";
import {Desktop} from "./Components/Desktop";
import {userConfiguration} from "../config";

document.oncontextmenu = (event) => false;

const root = document.getElementById('root');
if (root !== null) {
    document.addEventListener('DOMContentLoaded', () => {
        const loadingMessages = [
            "Initializing System",
            "Starting System Services",
            "Starting Storage Services",
            "Starting Application Services",
            "Hacking ISRO servers",
            "Doing Something Secret",
            "Starting Desktop Interface",
        ];

        const progressBar = document.getElementById('progress-bar');
        const progressMessage = document.getElementById('progress-message');
        let currentIndex = 0;
        const intervalId = setInterval(() => {
            if (currentIndex >= loadingMessages.length) {
                clearInterval(intervalId);
                const progressContainer = document.getElementById('progress-container');
                if (progressContainer != null) {
                    root.removeChild(progressContainer);
                }
                document.body.style.background = "";
                document.body.style.backgroundImage = `url('${userConfiguration.BackgroundProvider()}')`;

                const taskbar = new Taskbar();
                taskbar.render(root);

                // const contentMenu = new ContentMenu();
                // contentMenu.start();

                const desktop = new Desktop();
                desktop.render(root);
            }
            if (progressBar != null) {
                progressBar.style.width = ((currentIndex / loadingMessages.length) * 100) + "%";
            }

            if (progressMessage != null) {
                progressMessage.innerText = loadingMessages[currentIndex];
            }

            currentIndex++;
        }, 500);
    });
}


